<template>
  <StackedListRowTwoColumnRightCentered :name="tripDestinations" dontStackIcons>
    <template #left-bottom>
      <StackedListRowIconWithText :icon="CalendarIcon">{{
        formattedDepartureDate
      }}</StackedListRowIconWithText>

      <StackedListRowIconWithText
        v-if="props.trip.plane"
        class="mt-2"
        :icon="PaperAirplaneIcon"
        >{{ props.trip.plane.tail_number }}</StackedListRowIconWithText
      >

      <StackedListRowIconWithText class="mt-2" :icon="UserGroupIcon">{{
        props.trip.flyers_or_owners_list
      }}</StackedListRowIconWithText>
    </template>
    <template #right>
      <div class="flex mr-1">
        <SpanText
          class="flex"
          color="text-gray-600"
          font="text-sm"
          v-for="(airportCode, index) in airportCodes"
        >
          {{ airportCode }}
          <ArrowSmRightIcon
            v-if="index < airportCodes.length - 1"
            class="h-4 w-4 my-auto"
          />
        </SpanText>
      </div>
    </template>
  </StackedListRowTwoColumnRightCentered>
</template>

<script setup>
import {
  CalendarIcon,
  ArrowSmRightIcon,
  PaperAirplaneIcon,
  UserGroupIcon,
} from '@heroicons/vue/solid'
import { computed } from 'vue'
import SpanText from '@/Common/Text/SpanText.vue'
import {
  getAirportCodesFromTripLegs,
  getMunicipalitiesFromTripLegs,
} from './Common'
import StackedListRowTwoColumnRightCentered from '@/Common/Lists/StackedLists/Rows/StackedListRowTwoColumnRightCentered.vue'
import StackedListRowIconWithText from '@/Common/Lists/StackedLists/Rows/Parts/StackedListRowIconWithText.vue'

const props = defineProps({
  trip: Object,
})

const tripDestinations = computed(() => {
  return getMunicipalitiesFromTripLegs(props.trip.legs)
})

const airportCodes = computed(() => {
  return getAirportCodesFromTripLegs(props.trip.legs)
})

const formattedDepartureDate = computed(() => {
  if (!props.trip.legs?.length) return 'N/A'

  return props.trip.formatted_departure_date
})
</script>
